const headerElement = document.querySelector('.header');
const screenElement = document.querySelector('.intro__screen');

const edgeOffset = 70;
const screentTopEdge = window.pageYOffset + screenElement.getBoundingClientRect().top - edgeOffset;

const checkHeaderVisible = () => {
  if (window.pageYOffset > screentTopEdge) {
    headerElement.classList.add('header--visible');
  } else {
    headerElement.classList.remove('header--visible');
  }
};

const onWindowScroll = () => {
  checkHeaderVisible();
};

const initHeader = () => {
  checkHeaderVisible();
  window.addEventListener('scroll', onWindowScroll);
};

export default initHeader;
